export const EmailNotificationDrawerLabels = {
  createAccount: ' has createad an account ',
  createdProject: ' has created a Project ',
  under: ' under ',
  on: ' on ',
  suspendedProject: ' has suspended an Project ',
  editedProject: ' has edited ',
};
